import store from '../store'
import {
  mapDispatchToProps as actions
} from '../components/Alert/Alert.state'
import { NotifyType } from '../components/Notify'

function push (type: NotifyType, message: string) {
  store.dispatch(actions.push(type, message))
}

export default {
  info (message: string) {
    push('info', message)
  },

  success (message: string) {
    push('success', message)
  },

  error (message: string) {
    push('error', message)
  },

  instruction (message: string) {
    push('instruction', message)
  },

  warning (message: string) {
    push('warning', message)
  },

  clear () {
    store.dispatch(actions.clear())
  }
}
